<template>
  <div class="pay">
    <div class="pay-list">
      <template v-for="(item, index) in list" :key="item.payment_id">
        <div class="pay__item" v-if="item.payment_id !== 5" @click="check(index)">
          <div class="pay-header">
            <img class="pay-logo" :src="item.logo" />
          </div>
          <div class="pay-info">
            <div class="pay-info__title">
              <span>{{ item.payment_name }}</span
              ><span class="pay-info__text" v-if="item.paymentCode == 'integral'"
                >（当前可用{{ integralName }}{{ item.integral_balance }}）</span
              >
              <span class="pay-info__text" v-if="item.paymentCode == 'wallet'">（钱包余额{{ item.balance }}）</span>
            </div>
          </div>
          <SvgIcon v-if="item.isSelect" name="icon-fuxuan" size="0.64rem" :color="theme.PerformanceSelectIconColor" />
          <img
            v-else
            style="width: 0.64rem; height: 0.64rem"
            slot="icon"
            src="https://x.jzbull.com/x_dsx_wxapp/icov_newPart/xuan0.png"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { getLocal } from '@/common/js/utils'
import { useUserStore } from '@/store/user'
export default {
  components: {
    SvgIcon
  },
  props: {
    show: {
      type: Boolean,
      value: true
    },
    list: {
      type: Array,
      value: []
    }
  },
  emits: ['check'],
  setup(props, { emit }) {
    const userStore = useUserStore()
    const theme = computed(() => userStore.getTheme)
    onMounted(async () => {})

    function check(index) {
      emit('check', index)
    }

    return {
      check,
      theme
    }
  }
}
</script>

<!--<style lang="less" src="./pay.less"></style>-->
